import React from 'react';
import { Percent, Info, FileText, Calculator } from 'lucide-react';

/**
 * Компонент боковой панели с информацией о ставках НДС
 */
const TaxRatesSidebar = ({ vatRates }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Percent className="w-5 h-5 mr-2 text-indigo-500" />
        Ставки НДС в России
      </h3>

      <div className="space-y-3">
        {/* Основная ставка */}
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
          <div className="flex items-start gap-3">
            <div className="tax-rate-badge tax-rate-badge-20 mt-0.5">20%</div>
            <div>
              <h4 className="text-sm font-medium text-blue-800 dark:text-blue-300">Основная ставка</h4>
              <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                Применяется к большинству товаров и услуг
              </p>
              <p className="text-xs text-blue-500 dark:text-blue-300 mt-1 font-medium">
                Расчетная ставка: 20/120 = 16.67%
              </p>
            </div>
          </div>
        </div>

        {/* Пониженная ставка */}
        <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
          <div className="flex items-start gap-3">
            <div className="tax-rate-badge tax-rate-badge-10 mt-0.5">10%</div>
            <div>
              <h4 className="text-sm font-medium text-green-800 dark:text-green-300">Пониженная ставка</h4>
              <p className="text-xs text-green-600 dark:text-green-400 mt-1">
                Продукты питания, детские товары, лекарства, периодика
              </p>
              <p className="text-xs text-green-500 dark:text-green-300 mt-1 font-medium">
                Расчетная ставка: 10/110 = 9.09%
              </p>
            </div>
          </div>
        </div>

        {/* Нулевая ставка */}
        <div className="p-3 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg">
          <div className="flex items-start gap-3">
            <div className="tax-rate-badge tax-rate-badge-0 mt-0.5">0%</div>
            <div>
              <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200">Нулевая ставка</h4>
              <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                Экспорт товаров, международные перевозки
              </p>
            </div>
          </div>
        </div>

        {/* Без НДС */}
        <div className="p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-800 rounded-lg">
          <div className="flex items-start gap-3">
            <div className="tax-rate-badge tax-rate-badge-exempt mt-0.5">Без НДС</div>
            <div>
              <h4 className="text-sm font-medium text-amber-800 dark:text-amber-300">Освобождение от НДС</h4>
              <p className="text-xs text-amber-600 dark:text-amber-400 mt-1">
                Медицинские, образовательные, финансовые услуги и др.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Полезные ссылки */}
      <div className="mt-5">
        <h4 className="text-sm font-medium text-gray-900 dark:text-white flex items-center mb-3">
          <Info className="w-4 h-4 mr-2 text-indigo-500" />
          Полезная информация
        </h4>
        <ul className="space-y-2 text-sm">
          <li>
            <a href="https://www.nalog.gov.ru/rn77/taxation/taxes/nds/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300">
              <FileText className="w-4 h-4" />
              НДС на сайте ФНС России
            </a>
          </li>
          <li>
            <a href="http://www.consultant.ru/document/cons_doc_LAW_28165/35cc6698564adc4507baa31c9cfdbb4f2516d068/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300">
              <FileText className="w-4 h-4" />
              Глава 21 НК РФ "Налог на добавленную стоимость"
            </a>
          </li>
          <li>
            <a href="#" className="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300">
              <Calculator className="w-4 h-4" />
              Калькулятор УСН
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TaxRatesSidebar;